<template>
  <div class="convention-hall page">
    <van-nav-bar
        class="nav-bar"
        :title="$t('game.title')"
    />
    <div class="convention-item area news">
      <div class="brands" style="margin-top: 10px;">
        <div class="item" v-for="(item,key) in gameitem" :key="key" @click="toLottery(item.key,item.id)">
          <img class="mr-[16rpx] w-[80rpx] h-[80rpx]" :src="item.ico">
          <div>
            <div class="name u-font-28 u-line-1 mb-[12rpx]">{{ item.name }}</div>
            <div class="frequency u-font-24"></div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {Toast} from 'vant';

export default {
  data() {
    return {
      gameitem: [{}, {}, {}, {}],
      lotteryitem: [{}, {}, {}, {}],
      isLoading: false,
      activeKey: 0,
    };
  },
  methods: {
    onRefresh() {
      setTimeout(() => {
        Toast(this.$t("msg.刷新成功！"));
        this.isLoading = false;
      }, 500);
    },
    toLottery(key, id) {
      if (!localStorage.getItem('token')) {
        this.$router.push({path: '/Login'})
      } else {
        this.$router.push({path: '/Lottery?key=' + key + "&id=" + id})
      }
    },
    getGameItem() {
      this.$http({
        method: 'get',
        url: 'lottery_list'
      }).then(res => {
        this.gameitem = res.data;
      })
    },
    onChange(index) {
      this.$http({
        method: 'get',
        data: {class: index},
        url: 'lottery_list'
      }).then(res => {
        this.gameitem = res.data;
      })
    },
    getLotteryItem() {
      this.$http({
        method: 'get',
        url: 'lottery_class'
      }).then(res => {
        this.lotteryitem = res.data;
      })
    }
  },
  created() {
    this.getGameItem();//获取首页游戏列表
    this.getLotteryItem();
  }
};
</script>

<style lang='less' scoped>
.u-font-28{
  font-size: 28px;
}
.news{
  padding: 10px 50px 150px;
  overflow: auto;
  background-color: #fff;
}
.area .brands {
  display: flex;
  flex-direction: column
}

.area .brands .item {
  width: 100%;
  border-radius: .5rem;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding: 30px
}

.area .brands .item,.area .brands .item:nth-child(5n+1) {
  background: linear-gradient(180deg,#ebcbfe,#f3ecf6)
}

.area .brands .item:nth-child(5n+2) {
  background: linear-gradient(180deg,#f7f5cb,#f6f5eb)
}

.area .brands .item:nth-child(5n+3) {
  background: linear-gradient(180deg,#ddf7cb,#eef5e7)
}

.area .brands .item:nth-child(5n+4) {
  background: linear-gradient(180deg,#cbe6fa,#e0f2fb)
}

.area .brands .item:nth-child(5n+5) {
  background: linear-gradient(180deg,#fdcfd6,#f5eff0)
}

.area .brands .item:last-child {
  margin-bottom: 0
}

.area .brands .item .name {

  color: #2a3563
}

.area .brands .item .frequency {
  color: #848fac
}

.w-\[80rpx\] {
  width: 80px;
  border-radius: 50%;
}

.h-\[80rpx\] {
  height: 80px
}

.mr-\[16rpx\] {
  margin-right: .5rem
}

</style>
